import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { fetchNiches } from "@/lib/api";
import * as Icons from "lucide-react";

export default function NichesPage() {
  const [niches, setNiches] = useState([]);

  useEffect(() => { fetchNiches().then((d) => setNiches(d.niches)).catch(console.error); }, []);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-8 py-12">
      <p className="uppercase text-xs tracking-[0.2em] font-semibold text-slate-500 mb-2">Niche Explorer</p>
      <h1 className="font-heading text-4xl md:text-5xl tracking-tight mb-4">10 niches, ranked and researched.</h1>
      <p className="text-slate-600 max-w-2xl mb-12 leading-relaxed">Each niche page includes top programs, average EPC benchmarks and profitability insights to help you pick your lane.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {niches.map((n) => {
          const Icon = Icons[n.icon] || Icons.Folder;
          return (
            <Link key={n.slug} to={`/niches/${n.slug}`} data-testid={`niche-page-card-${n.slug}`} className="card-lift bg-white border border-slate-200 rounded-lg p-8 group">
              <div className="flex items-start justify-between">
                <Icon className="w-8 h-8 text-emerald-600 mb-4" strokeWidth={1.8} />
                <ArrowRight className="w-5 h-5 text-slate-300 group-hover:text-emerald-600 group-hover:translate-x-1 transition-transform duration-200" />
              </div>
              <h2 className="font-heading text-xl font-semibold tracking-tight group-hover:text-emerald-700 transition-colors duration-200">{n.name}</h2>
              <p className="text-sm text-slate-600 mt-2 leading-relaxed">{n.description}</p>
              <div className="flex gap-8 mt-6 pt-5 border-t border-slate-100">
                <div><p className="font-heading text-lg font-medium">{n.program_count}</p><p className="text-xs text-slate-500 uppercase tracking-wider">Programs</p></div>
                <div><p className="font-heading text-lg font-medium">${n.avg_epc}</p><p className="text-xs text-slate-500 uppercase tracking-wider">Avg EPC</p></div>
                <div className="flex-1 min-w-0"><p className="text-sm font-medium truncate">{n.top_programs.join(", ")}</p><p className="text-xs text-slate-500 uppercase tracking-wider">Top programs</p></div>
              </div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
